var map = {
	"./assets/clickable/wantedly.svg": "5cf592eba885419c60a3",
	"./assets/disabled/wantedly.svg": "275ee420908172e75339",
	"./assets/original/wantedly.svg": "128e1a0aab43f8ab4794"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "02f58c4df8c76d619170";